// src/pages/Dashboard/StatsTable.js
import React from "react";
import useChatbotStats from "./useChatbotStats";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function ChatbotStatsTable() {
    const { stats, error, loading } = useChatbotStats();

    if (loading) return (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress size={24} />
             <Typography sx={{ ml: 2 }}>Loading stats table...</Typography>
        </Box>
    );
    if (error) return <div className="alert alert-danger">{error}</div>;
    if (!stats) return <div>No stats available for this chatbot.</div>;

    return (
        <div>
            <h4>Knowledge Base Statistics</h4>
            <div className="card">
                <div className="card-body">
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th className="text-end">Total Characters</th>
                                <th className="text-end">Total Words</th>
                                <th className="text-end">Total Source Tokens</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Private Documents</td>
                                <td className="text-end">{stats.privateDocs.total_page_characters}</td>
                                <td className="text-end">{stats.privateDocs.total_page_words}</td>
                                <td className="text-end">{stats.privateDocs.total_tokens}</td>
                            </tr>
                            <tr>
                                <td>Website Links</td>
                                <td className="text-end">{stats.websiteLinks.total_page_characters}</td>
                                <td className="text-end">{stats.websiteLinks.total_page_words}</td>
                                <td className="text-end">{stats.websiteLinks.total_tokens}</td>
                            </tr>
                            <tr>
                                <td>Total (Knowledge Base)</td>
                                <td className="text-end">{stats.totalCharacters}</td>
                                <td className="text-end">{stats.totalWords}</td>
                                <td className="text-end">{stats.totalTokens}</td>
                            </tr>
                            <tr>
                                <td>Chatbot Usage (Input + Output)</td>
                                <td className="text-end" colSpan={2}></td>
                                <td className="text-end">{stats.tokens.total_total_token}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}